import posthog from "posthog-js";

// Initialize PostHog with your project API key
// Replace 'your-api-key' with your actual PostHog API key
// You should get this from your PostHog instance
posthog.init(process.env.POSTHOG_API_KEY || "", {
  api_host: "https://app.posthog.com", // or your self-hosted instance URL
  // Enable debug mode in development
  debug: process.env.NODE_ENV === "development",
  // Only capture events in production
  loaded: (posthog) => {
    if (process.env.NODE_ENV === "development") {
      // Disable capturing in development by default
      posthog.opt_out_capturing();
    }
  },
});

export default posthog;
